<template>
  <div>
    <background-wrapper src="media-articles/fullscreen-image_post-hero" ext="png" :media="false">
      <div class="hero"></div>
    </background-wrapper>
    <article class="single-post">
      <b-link class="single-post__back" to="/media-articles">
        <img src="@/assets/arrow-left-small.svg">
        {{$t(`${$route.name}.back-to-media-list`)}}
      </b-link>
      <div class="post post--big">
        <div class="post__image">
          <img :src="$cmsDomain + post.largeImage" v-if="post.largeImage">
        </div>
        <div class="post__info">
          <h1 class="post__title">{{post.title}}</h1>
        </div>
      </div>
      <container-small class="mt-6">
        <div class="body">
          <div class="body__content">
            <p class="mb-4" v-if="post.content" v-html="post.content"/>
          </div>
        </div>
      </container-small>
    </article>
    <div v-if="relatedPosts.length" class="related">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h2 class="h2 mb-0" v-html="$t(`${$route.name}.related`)"/>
        <b-link class="font-weight-bold" to="/media-articles">{{$t(`${$route.name}.see-all`)}}</b-link>
      </div>
      <VueSlickCarousel class="related__posts" :dots="true" v-bind="settings">
        <Post class="related__post" v-for="post in relatedPosts" :post="post" :key="post.url" vertical/>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import dayjs from 'dayjs'
import { Post } from '@/components/ui/mediaArticles'

export default {
  name: 'MediaPost',
  metaInfo () {
    return {
      title: this.post.title,
      meta: [
        { name: 'description', content: this.post.summary },
        { name: 'twitter:title', content: this.post.title },
        { name: 'twitter:description', content: this.post.summary },
        { property: 'og:title', content: this.post.title },
        { property: 'og:description', content: this.post.summary }
      ]
    }
  },
  data () {
    return {
      post: {},
      relatedPosts: [],
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    }
  },
  beforeMount () {
    this.axios.get(`${process.env['CMS_DOMAIN']}/api/media/articles/` + this.$route.params.id)
      .then(data => {
        this.post = data.data
      })
      .catch(err => {
        console.log(err)
        this.post = {}
      })
  },
  mounted () {
    this.axios.get(`${process.env['CMS_DOMAIN']}/api/media/articles`)
      .then(data => {
        this.relatedPosts = data.data.filter(post => post.title !== this.post.title).sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)).slice(0, 3)
      })
      .catch(err => {
        console.log(err)
        this.relatedPosts = []
      })
  },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  },
  components: { VueSlickCarousel, Post },
  methods: {
    formatDate (dateString) {
      const date = dayjs(dateString).add('1', 'day')
      return date.format('MMMM D, YYYY')
    }
  }
}
</script>

<style lang="sass" scoped>
.hero
  padding-top: 415px

.single-post
  margin-top: -390px
  position: relative
  z-index: 1

  &__back
    display: inline-block
    margin-bottom: 15px
    font-weight: bold
    color: $dark
    img
      margin-right: 5px

  .post__title
    font-size: 2.5rem

  .body
    +media-breakpoint-up(md)
      display: flex
      padding: 0 50px

      &__social-links
        padding: 0 55px
    +media-breakpoint-down(sm)
      margin-top: -60px
      .nav
        margin-left: -10px
        margin-bottom: 20px
        flex-direction: row!important

.related
  margin: 60px 0 140px

  &__posts
    margin: 0 -14px

  &__post
    padding: 0 14px 28px

.post
  display: flex
  align-items: center
  &:not(&--big):not(&--vertical)
    padding: 20px 0
    &:not(:last-child)
      border-bottom: solid 1px #E7E7EA

  &--big
    +media-breakpoint-down(md)
      flex-direction: column

  &--vertical
    flex-direction: column

  &__image
    flex: 1
    max-width: 240px
    width: 100%
    +media-breakpoint-down(sm)
      max-width: 210px
    +media-breakpoint-down(xs)
      max-width: 150px

    img
      width: 100%
      height: 100%
      object-fit: cover

  &--big &__image
    max-width: 100%
    +media-breakpoint-up(md)
      max-width: none
      width: 100%
      padding-right: 28px

  &--vertical &__image
    max-width: 100%
    width: 100%

  &__info
    flex: 1
    padding: 28px
    padding-right: 0

  &--big &__info
    padding: 40px 0 40px 28px
    +media-breakpoint-down(sm)
      padding: 28px 0 0 0

  &--vertical &__info
    padding: 28px 0 0 0

  &__category-name
    display: inline-block
    margin-bottom: 7px
    font-size: 12px
    font-weight: bold
    text-transform: uppercase
    letter-spacing: .8px
    color: $primary

  &__title
    margin-bottom: 6px
    a
      color: $dark

  &__body
    margin-top: 18px
    margin-bottom: 10px

  &__created-at
    color: #666B75
</style>



// WEBPACK FOOTER //
// src/components/mediaArticles/MediaPost.vue